'use client'

import { type FC } from 'react'

import { DirectContactFormHookFormDialog } from '../DirectContactFormHookFormDialog/DirectContactFormHookFormDialog'
import { type DirectContactFormHookFormDialogProps } from '../DirectContactFormHookFormDialog/DirectContactFormHookFormDialogModel'

export const DirectContactFormDialogWrapper: FC<
  DirectContactFormHookFormDialogProps
> = (props) => <DirectContactFormHookFormDialog {...props} />
